import {css} from 'styled-components'

import {colors, focusRingSizes} from '@/theme'

export type FocusStylesSpread = keyof typeof focusRingSizes

export const focusStyles = (spread: FocusStylesSpread = 'thin') => css`
    border-color: transparent;

    /* Set outline as Windows high-contrast mode fallback */
    outline: transparent solid 2px;
    box-shadow: 0 0 0 ${focusRingSizes[spread]} ${colors.focusRing};
`

export const ellipsisStyles = css`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`

export const buttonResetStyles = css`
    /* Prevent iOS/Safari blue styling */
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;

    /* Prevent iOS tap highlight and callout flash */
    -webkit-tap-highlight-color: transparent;
    -webkit-touch-callout: none;
    border: none;
    background: transparent;
    margin: 0;
    font: inherit;
    cursor: pointer;
    outline: none;
    user-select: none;
`
